import React from "react"
import { graphql } from "gatsby"

import { Meta } from "@shared"
import { CONSTANTS } from "@data"
import { logTool } from "@jsUtils"

import { Footer, Header, Banner, Careers, JoinUs } from "@components/sections"

const { THEMES, COLORS, PAGE_TRACKER_KEYS, PAGE_TRACKER_VALUES } = CONSTANTS

const log = logTool()

/**
 * Vision Page
 * @param {object} props - react props
 * @todo hook up meta data
 */
// eslint-disable-next-line no-unused-vars
const CareersPage = props => {
  const { data } = props
  const { contentfulPageMeta, contentfulCareers } = data
  const { bottomBanner } = contentfulCareers
  log("Careers Content:", { contentfulCareers, contentfulPageMeta })

  return (
    <>
      <Meta
        base={contentfulPageMeta}
        page={contentfulCareers}
        hubSpotObj={{
          contentTypeKey: PAGE_TRACKER_KEYS.CAREERS,
          contentTypeValue: PAGE_TRACKER_VALUES.WEBSITE_PAGE
        }}
      />
      <Header theme={THEMES.LIGHT} pageColor={COLORS.DARK} />
      <Careers theme={THEMES.LIGHT} color={COLORS.FLURO} data={contentfulCareers} />
      <JoinUs theme={THEMES.TIN} color={COLORS.FLURO} />
      <Banner data={bottomBanner} />
      {/* {isModalEnabledOnSite ? (
        <EmailModal data={contentfulCrmEventBasedModal} theme={THEMES.DARK} color={COLORS.FLURO} />
      ) : null} */}
      <Footer />
    </>
  )
}

/**
 * pageQuery for Our Vision Page
 * @todo is there a way to make the global data a fragment?
 */
export const pageQuery = graphql`
  {
    contentfulPageMeta(id: { eq: "423babd8-0278-5b2e-85f6-77fb7ee55bee" }) {
      pageTitle
      description
      keywords
      socialImage {
        file {
          url
          details {
            image {
              height
              width
            }
          }
        }
      }
    }
    contentfulCrmEventBasedModal {
      heroImage {
        title
        fluid(quality: 100, maxWidth: 1920) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      supportingText
      heroText
      isModalEnabledOnSite
    }
    contentfulCareers {
      pageMeta {
        ...PageMetaData
      }
      bottomBanner {
        ...BannerSection
      }
      ...CareersSection
    }
  }
`

export default CareersPage
